"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatedFormSubmissions = exports.setFormSubmissions = exports.setFormReleases = exports.selectedReportFormRelease = exports.selectedReportForm = exports.updatedUniqueUserAttributes = exports.updatedUniquePositions = exports.updatedCredentials = exports.archivedForm = exports.updatedForm = exports.addedForm = exports.setForms = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const INITIAL_STATE_2 = {
    forms: [],
    credentials: {},
    uniquePositions: [],
    uniqueUserAttributes: [],
    report: {},
};
const formsSlice = (0, toolkit_1.createSlice)({
    name: 'forms',
    initialState: INITIAL_STATE_2,
    reducers: {
        setForms: (state, action) => {
            state.forms = action.payload;
            return state;
        },
        addedForm: (state, action) => {
            state.forms.push(action.payload);
            return state;
        },
        updatedForm: (state, action) => {
            const index = state.forms.findIndex((form) => form.id === action.payload.id);
            if (index < 0) {
                return;
            }
            state.forms[index] = action.payload;
            return state;
        },
        archivedForm: (state, action) => {
            const index = state.forms.findIndex((form) => form.id === action.payload);
            if (index >= 0) {
                state.forms[index].archived = true;
            }
            return state;
        },
        updatedCredentials: (state, action) => {
            state.credentials = action.payload;
            return state;
        },
        updatedUniquePositions: (state, action) => {
            state.uniquePositions = action.payload;
            return state;
        },
        updatedUniqueUserAttributes: (state, action) => {
            state.uniqueUserAttributes = action.payload;
            return state;
        },
        // reports
        selectedReportForm: (state, action) => {
            state.report.selectedForm = action.payload;
            return state;
        },
        selectedReportFormRelease: (state, action) => {
            state.report.selectedFormRelease = action.payload;
            return state;
        },
        setFormReleases: (state, action) => {
            state.report.formReleases = action.payload;
            return state;
        },
        setFormSubmissions: (state, action) => {
            state.report.formSubmissions = action.payload;
            return state;
        },
        updatedFormSubmissions: (state, action) => {
            state.report.formSubmissions = action.payload;
            return state;
        },
    },
});
exports.default = formsSlice.reducer;
_a = formsSlice.actions, exports.setForms = _a.setForms, exports.addedForm = _a.addedForm, exports.updatedForm = _a.updatedForm, exports.archivedForm = _a.archivedForm, exports.updatedCredentials = _a.updatedCredentials, exports.updatedUniquePositions = _a.updatedUniquePositions, exports.updatedUniqueUserAttributes = _a.updatedUniqueUserAttributes, exports.selectedReportForm = _a.selectedReportForm, exports.selectedReportFormRelease = _a.selectedReportFormRelease, exports.setFormReleases = _a.setFormReleases, exports.setFormSubmissions = _a.setFormSubmissions, exports.updatedFormSubmissions = _a.updatedFormSubmissions;
